import ball from "./ball";
import paint from "./paint";
import { StatefulSketch } from "../lib";

// TODO will generate this file

export default [ball, paint] as StatefulSketch<any>[];
